export default __webpack_public_path__ + "static/media/footer-facebook.4e579a3a.svg";